import { useState, useEffect } from 'react';
import axios from 'axios';
import { createApiUrl } from '../../../Config/apiConfig';

export const useGamesData = () => {
    const [gamesList, setGamesList] = useState([]);
    const [gtpGamesData, setGtpGamesData] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchGamesData = async () => {
            try {
                const [gameInfoResponse, gameFlexResponse] = await Promise.all([
                    axios.get(createApiUrl('GameInfo')),
                    axios.get(createApiUrl('CoreflexData/fetch-games')),
                ]);

                const mergedGames = gameInfoResponse.data.map((game) => {
                    const match = gameFlexResponse.data.find(
                        (gf) => gf.LaunchCode.toLowerCase() === game.launchID.toLowerCase()
                    );

                    // Determine platform based on launch ID prefix and client ID
                    let platform = '';
                    if (game.launchID && game.launchID.startsWith('GGV_')) {
                        platform = 'Forge';
                    } else if (game.clientId.toString().startsWith('4')) {
                        platform = 'Mobile';
                    } else if (game.clientId.toString().startsWith('5')) {
                        platform = 'Desktop';
                    }

                    return {
                        ...game,
                        GameflexGameID: match ? match.GameflexGameID : null,
                        platform: platform
                    };
                });

                // Filter out games with empty platform or launchID
                const validGames = mergedGames.filter(game =>
                    game.platform &&
                    game.platform.trim() !== '' &&
                    game.launchID &&
                    game.launchID.trim() !== '' &&
                    game.clientId.toString().length > 1 // Only filter out single-digit clientIds
                );

                setGamesList(validGames);
                setLoading(false);
            } catch (error) {
                console.error('Error fetching data:', error);
                setLoading(false);
            }
        };

        const fetchGtpGamesData = async () => {
            try {
                const response = await axios.get(createApiUrl('gtp/games'));
                setGtpGamesData(response.data);
            } catch (error) {
                console.error('Error fetching GTP games data:', error);
            }
        };

        fetchGamesData();
        fetchGtpGamesData();
    }, []);

    return { gamesList, gtpGamesData, loading };
};